import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Card,
  CardHeader,
  // Alert,
  // AlertTitle,
  // Avatar,
  // CardContent,
  Typography
} from '@mui/material';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ArticleIcon from '@mui/icons-material/Article';
import ScheduleIcon from '@mui/icons-material/Schedule';

function InvoiceAmountCard({ data }) {
  // const alertStyle = {
  //   borderRadius: '8px',
  //   alignItems: 'center',
  //   p: 2,
  //   '.MuiAlert-icon': {
  //     '.MuiSvgIcon-root': {
  //       fontSize: '50px'
  //     }
  //   },
  //   '&.MuiAlert-outlinedSuccess': {
  //     background: 'rgb(237, 247, 237)',
  //     boxShadow: '2px 2px 7px 0px rgba(51, 153, 51, 0.65)'
  //   },
  //   '&.MuiAlert-outlinedWarning': {
  //     background: 'rgb(255, 244, 229)',
  //     boxShadow: '2px 2px 7px 0px rgba(255, 152, 0, 0.65)'
  //   },
  //   '&.MuiAlert-outlinedInfo': {
  //     background: 'rgb(229, 246, 253)',
  //     boxShadow: '2px 2px 7px 0px rgba(3, 169, 244, 0.65)'
  //   },
  //   '&.MuiAlert-outlinedError': {
  //     background: 'rgb(253, 237, 237)',
  //     boxShadow: '2px 2px 7px 0px rgba(239, 83, 80, 0.65)'
  //   },
  //   '&.MuiAlert-outlinedPrimary': {
  //     // background: '#002C3E',
  //     background: '#87f1ce54',
  //     boxShadow: '2px 2px 7px 0px #08ddcda6',
  //     border: '1px solid #00ac9f',
  //     // boxShadow: '2px 2px 7px 0px rgba(239, 83, 80, 0.65)',
  //     height: '100%',
  //     p: 5,
  //     '.MuiAlertTitle-root': {
  //       fontSize: '40px',
  //       lineHeight: '45px',
  //       color: '#002c3e',
  //       mb: 0
  //     },
  //     '.alertContent': {
  //       fontSize: '20px',
  //       lineHeight: '25px',
  //       fontWeight: '400',
  //       color: '#002c3e',
  //       m: 0
  //     }
  //   }
  // };
  const cardStyle = {
    boxShadow: '0 0 20px 3px #96beee26',
    border: '0px',
    borderStyle: 'solid',
    borderBottomWidth: '6px',
    lineHeight: '20px',
    fontWeight: '400',
    margin: '0px'
  };
  const titleStyle = {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: '400'
  };
  const contentStyle = {
    fontSize: '13px',
    color: '#777',
    lineHeight: '20px',
    fontWeight: '700',
    margin: '0px 0 5px'
  };

  return (
    <Box className="newCardWrap" sx={{ p: 3, height: '100%' }}>
      <Grid container spacing={4}>
        <Grid item xs={12} xl={12}>
          <Box>
            <Grid container spacing={4}>
              <Grid item xs={4} xl={3}>
                <Card sx={{ ...cardStyle, bgcolor: 'primary.main', borderColor: 'transparent' }}>
                  <CardHeader
                    avatar={<ArticleIcon fontSize="large" sx={{ color: '#fff' }} />}
                    title={
                      <Typography variant="h2" sx={{ ...contentStyle, color: '#fff' }}>
                        Total
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={{ ...titleStyle, color: '#fff' }}>
                        {`${data?.currency} ${data?.totalAmount}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={4} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'paid.main' }}>
                  <CardHeader
                    avatar={<CheckCircleIcon fontSize="large" sx={{ color: 'paid.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Paid
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.totalReceivable}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={4} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'pending.main' }}>
                  <CardHeader
                    avatar={<WatchLaterIcon fontSize="large" sx={{ color: 'pending.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Pending
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.totalPending}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={6} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'overdue.main' }}>
                  <CardHeader
                    avatar={
                      <NotificationsActiveIcon fontSize="large" sx={{ color: 'overdue.main' }} />
                    }
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Overdue
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.totalOverDue}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={6} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'draft.main' }}>
                  <CardHeader
                    avatar={<ArticleIcon fontSize="large" sx={{ color: 'draft.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Draft
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.totalDraft}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={6} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'partialpayment.main' }}>
                  <CardHeader
                    avatar={<ArticleIcon fontSize="large" sx={{ color: 'partialpayment.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Partial Payment
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.partialPayment}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={6} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'writeoff.main' }}>
                  <CardHeader
                    avatar={<ArticleIcon fontSize="large" sx={{ color: 'writeoff.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Write off
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.writeOff}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
              <Grid item xs={6} xl={3}>
                <Card sx={{ ...cardStyle, borderColor: 'scheduled.main' }}>
                  <CardHeader
                    avatar={<ScheduleIcon fontSize="large" sx={{ color: 'scheduled.main' }} />}
                    title={
                      <Typography variant="h2" sx={contentStyle}>
                        Scheduled
                      </Typography>
                    }
                    subheader={
                      <Typography variant="h2" sx={titleStyle}>
                        {`${data?.currency} ${data?.scheduled}`}
                      </Typography>
                    }
                  />
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/* <Grid item xs={4} xl={4}>
          <Box sx={{ height: '100%' }}>
            <Alert icon={false} sx={alertStyle} variant="outlined" severity="primary">
              <AlertTitle sx={titleStyle}>
                {data && `${data.currency} ${data.totalAmount}`}
              </AlertTitle>
              <p className="alertContent">Total Amount</p>
            </Alert>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}

InvoiceAmountCard.defaultProps = {
  data: {
    totalReceivable: '0.00',
    totalPending: '0.00',
    totalOverDue: '0.00',
    totalDraft: '0.00',
    totalAmount: '0.00',
    partialPayment: '0.00',
    writeOff: '0.00',
    currency: 'USD'
  }
};

InvoiceAmountCard.propTypes = {
  data: PropTypes.shape({
    totalReceivable: PropTypes.string.isRequired,
    totalPending: PropTypes.string.isRequired,
    totalOverDue: PropTypes.string.isRequired,
    totalDraft: PropTypes.string.isRequired,
    totalAmount: PropTypes.string.isRequired,
    partialPayment: PropTypes.string.isRequired,
    writeOff: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    scheduled: PropTypes.string.isRequired
  })
};

export default InvoiceAmountCard;
